import type Paginated from 'app/core/paginable';

import httpApiApplication from '../../../../http/httpApiApplication';
import { type ReportRow, type TaxRow } from '../../TaxpayerRequest/types';
import {
  type ApproveRejectDto,
  type TaxpayerRegistrationConfiguration,
  type TaxpayerRequestPaginatedResponse,
  type TaxpayerRequestParams
} from '../types';

export const baseUrl = '/taxpayerrequest';

class TaxpayerRequestService {
  TaxpayerRequestListPaging(
    page: number,
    pageSize: number,
    params: TaxpayerRequestParams = {} as TaxpayerRequestParams
  ): Promise<Paginated<TaxpayerRequestPaginatedResponse>> {
    return httpApiApplication.paginate<TaxpayerRequestPaginatedResponse>(
      baseUrl,
      page,
      pageSize,
      params
    );
  }

  approve(values: ApproveRejectDto): Promise<unknown> | Promise<any> {
    return httpApiApplication
      .post(`${baseUrl}/approve`, values)
      .then((response: any) => ({ response }))
      .catch((error: any) => ({ error }));
  }

  reject(values: ApproveRejectDto): Promise<unknown> | Promise<any> {
    return httpApiApplication
      .post(`${baseUrl}/reject`, values)
      .then((response: any) => ({ response }))
      .catch((error: any) => ({ error }));
  }

  requestAdditionalInformation(values: ApproveRejectDto): Promise<unknown> | Promise<any> {
    return httpApiApplication
      .post(`${baseUrl}/requestadditionalinformation`, values)
      .then((response: any) => ({ response }))
      .catch((error: any) => ({ error }));
  }

  getTaxPeriodicities(id: string) {
    const url = `/taxes/${id}/TaxPeriodicity/All`;
    return httpApiApplication.get(url);
  }

  getReportPeriodicities(id: string) {
    const url = `/reports/${id}/ReportPeriodicity/All`;
    return httpApiApplication.get(url);
  }

  async verifyPeriodicities(taxes: Array<TaxRow>, reports: Array<ReportRow>) {
    let ok = true;
    for (let index = 0; index < taxes.length; index++) {
      const resutl = (await this.getTaxPeriodicities(taxes[index].id)) as Array<any>;
      if (!resutl?.some((c: any) => c.id == taxes[index].periodicity.id)) {
        ok = false;
      }
    }
    if (ok) {
      for (let index = 0; index < reports.length; index++) {
        const resutl = (await this.getReportPeriodicities(reports[index].id)) as Array<any>;
        if (!resutl?.some((c: any) => c.id == reports[index].periodicity.id)) {
          ok = false;
        }
      }
    }
    return ok;
  }

  getConfiguration(): Promise<TaxpayerRegistrationConfiguration> {
    const url = baseUrl + '/configuration';
    return httpApiApplication.get(url);
  }
}

export default new TaxpayerRequestService();
